"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.importsSalesforceStartPostSlice = void 0;
const _api_1 = require("../../../api/index.js");
const sonar_analytics_1 = require("@sonar-software/sonar-analytics");
const xuder_1 = require("@sonar-software/xuder");
exports.importsSalesforceStartPostSlice = (0, xuder_1.createPostAsyncSlice)({
    additionalRequestSteps: [
        {
            actionHandler: (0, sonar_analytics_1.createLogSagaWithFn)(() => ({
                data: { type: 'Salesforce' },
                id: sonar_analytics_1.AMPLITUDE_EVENT.SYNC_STARTED
            })),
            type: xuder_1.SagaYieldType.Every
        }
    ],
    name: 'ImportsSalesforceStart',
    receive: true,
    request: true,
    requestHandler: _api_1.postStartSalesforceImport
});
//# sourceMappingURL=post.js.map